import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SafeModule } from "../@core/pipes/pipe-modules/safe.module";
import { SharedComponentsPublicModule } from "../pages/shared-components-public.module";
// Material Public Modules
import { MaterialBannerModule } from "./material/banner/banner.module";
import { MaterialCareerModule } from "./material/career/career.module";
import { MaterialContactFormModule } from "./material/contact-form/contact-form.module";
import { MaterialContactFormWithMapModule } from "./material/contact-form-with-map/contact-form-with-map.module";
import { MaterialCtaModule } from "./material/cta/cta.module";
import { MaterialCtaFormModule } from "./material/cta-form/cta-form.module";
import { MaterialCtaFormWithMapModule } from "./material/cta-form-with-map/cta-form-with-map.module";
import { MaterialCtaNewsletterModule } from "./material/cta-newsletter/cta-newsletter.module";
import { MaterialEcommerceModule } from "./material/e-commerce/e-commerce.module";
import { MaterialFeaturesColModule } from "./material/features-col/features-col.module";
import { MaterialFeaturesRowModule } from "./material/features-row/features-row.module";
import { MaterialFeaturesSliderModule } from "./material/features-slider/features-slider.module";
import { MaterialFooterModule } from "./material/footer/footer.module";
import { MaterialGridModule } from "./material/grid-images-list/grid-images-list.module";
import { MaterialHeaderModule } from "./material/header/header.module";
import { MaterialHeroModule } from "./material/hero/hero.module";
import { MaterialHeroBackgroundImageModule } from "./material/hero-background-image/hero-background-image.module";
import { MaterialHeroBackgroundVideoModule } from "./material/hero-background-video/hero-background-video.module";
import { MaterialHeroImageModule } from "./material/hero-image/hero-image.module";
import { MaterialHeroVideoModule } from "./material/hero-video/hero-video.module";
import { MaterialImageGalleryModule } from "./material/image-gallery/image-gallery.module";
import { MaterialInstagramModule } from "./material/instagram/instagram.module";
import { MaterialLogoModule } from "./material/logo/logo.module";
import { MaterialLogosModule } from "./material/logos/logos.module";
import { MaterialMapModule } from "./material/map/map.module";
import { MaterialOpenseaModule } from "./material/opensea/opensea.module";
import { MaterialPostsModule } from "./material/posts/posts.module";
import { MaterialPricingModule } from "./material/pricing/pricing.module";
import { ProductsMaterialModule } from "./material/Products/products.module";
import { MaterialProgressBarModule } from "./material/progress-bar/progress-bar.module";
import { MaterialReservationModule } from "./material/reservation/reservation.module";
import { SliderImagesMaterialModule } from "./material/slider/slider.module";
import { MaterialTeamModule } from "./material/team/team.module";
import { MaterialTestimonialsModule } from "./material/testimonials/testimonials.module";
import { MaterialTestimonialsAltStyleModule } from "./material/testimonials-alternative-style/testimonials-alternative-style.module";
import { MaterialTwitterModule } from "./material/twitter/twitter.module";
import { MaterialFeaturesImagesModule } from "./material/features-images/features-row.module";
import { MaterialShapeModule } from "./material/shape/shape.module";
@NgModule({
  imports: [
    CommonModule,
    SharedComponentsPublicModule,
    SafeModule.forRoot(),
    // Material Public Modules 
    MaterialBannerModule,
    MaterialCareerModule,
    MaterialContactFormModule,
    MaterialContactFormWithMapModule,
    MaterialCtaModule,
    MaterialCtaFormModule,
    MaterialCtaFormWithMapModule,
    MaterialCtaNewsletterModule,
    MaterialEcommerceModule,
    MaterialFeaturesColModule,
    MaterialFeaturesRowModule,
    MaterialFeaturesImagesModule,
    MaterialFeaturesSliderModule,
    MaterialFooterModule,
    MaterialGridModule,
    MaterialHeaderModule,
    MaterialHeroModule,
    MaterialHeroBackgroundImageModule,
    MaterialHeroBackgroundVideoModule,
    MaterialHeroImageModule,
    MaterialHeroVideoModule,
    MaterialImageGalleryModule,
    MaterialInstagramModule,
    MaterialLogoModule,
    MaterialLogosModule,
    MaterialMapModule,
    MaterialOpenseaModule,
    MaterialPostsModule,
    MaterialPricingModule,
    ProductsMaterialModule,
    MaterialProgressBarModule,
    MaterialReservationModule,
    SliderImagesMaterialModule,
    MaterialTeamModule,
    MaterialTestimonialsModule,
    MaterialTestimonialsAltStyleModule,
    MaterialTwitterModule,
    MaterialShapeModule
  ],
  exports: [
    SharedComponentsPublicModule,
  ],
})
export class PublicModule { }
